export default "__VITE_ASSET__CrkIEP4h__"